import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-company-estimator-page',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './company-estimator-page.component.html',
  styleUrl: './company-estimator-page.component.scss',
})
export class CompanyEstimatorPageComponent {
  numberOfLeads = 875;
  costPerLead = 137;
  closeRatePercent = 8;
  grossProfitPerJob = 6422;

  get totalLeadSpend(): number {
    const leads = this.toNumber(this.numberOfLeads);
    const cpl = this.toNumber(this.costPerLead);
    return leads * cpl || 0;
  }

  get jobsWon(): number {
    const leads = this.toNumber(this.numberOfLeads);
    const closeRate = this.toNumber(this.closeRatePercent) / 100;
    return leads * closeRate || 0;
  }

  get totalGrossProfit(): number {
    const jobs = this.jobsWon;
    const profitPerJob = this.toNumber(this.grossProfitPerJob);
    return jobs * profitPerJob || 0;
  }

  get netProfitAfterLeadCost(): number {
    return this.totalGrossProfit - this.totalLeadSpend || 0;
  }

  get costPerClosedJob(): number {
    const jobs = this.jobsWon;
    if (!jobs) {
      return 0;
    }
    return this.totalLeadSpend / jobs;
  }

  get returnOnLeadSpend(): number {
    const spend = this.totalLeadSpend;
    if (!spend) {
      return 0;
    }
    return this.netProfitAfterLeadCost / spend;
  }

  get revenueMultiple(): number {
    const spend = this.totalLeadSpend;
    if (!spend) {
      return 0;
    }
    return this.totalGrossProfit / spend;
  }

  private toNumber(value: unknown): number {
    const n = typeof value === 'string' ? parseFloat(value) : Number(value);
    return Number.isFinite(n) ? n : 0;
  }
}

